import { Link } from "react-router-dom";
import { genres } from "@/mocks/dramas";

export default function GenreGrid() {
  return (
    <section id="genres" className="py-16 md:py-20" aria-labelledby="genres-title">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-[0.3em] text-accent-400">按口味挑片</span>
          <h2 id="genres-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            六大口味分类，先定方向再选剧
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            不同口味的节奏和情绪完全不一样。先找到你今晚想看的感觉，再从对应分类里挑一部，比盲刷高效得多。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {genres.map((genre) => (
            <Link
              key={genre.slug}
              to={`/ranking?category=${genre.slug}`}
              className="group relative block overflow-hidden rounded-lg border border-background-200/70 cursor-pointer"
            >
              <div className="relative w-full" style={{ aspectRatio: "16 / 10" }}>
                <img
                  src={genre.image}
                  alt={`${genre.name} 类短剧封面`}
                  title={`${genre.name} 短剧分类`}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/50 to-transparent"></div>
              </div>

              <div className="absolute inset-x-0 bottom-0 p-5">
                <div className="flex items-center justify-between gap-3">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{genre.name}</h3>
                  <span className="rounded-full bg-primary-500/90 px-2.5 py-0.5 text-[11px] font-label text-background-950">
                    {genre.count} 部
                  </span>
                </div>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{genre.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-label text-accent-400">
                  进入分类
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}